import React from 'react'
import { CircularProgress } from '@material-ui/core'
// @src imports
import { DefaultError } from 'src/chrome'
import { getImages, ImageFragment } from 'src/graphql'
import { useMutations, useQueries } from 'src/hooks'

import Images from './Images'
import UploadFooter from './UploadFooter'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'

import { Api } from '../api'
import { Steps } from '../types'

type Props = {
  api: Api & { step: { type: Steps.EditPicture | Steps.EditBackgroundPicture } }
}

const SOCImages: React.FC<Props> = props => {
  const {
    api: { step, setElementImage },
  } = props
  const mutations = useMutations()

  const [{ results: images, isLoadingMore, hasMore, loadMore }] = useQueries(
    getImages(),
  )

  const onSelect = (image: ImageFragment) => {
    switch (step.type) {
      case Steps.EditPicture:
        setElementImage(
          step.fullBleedIndex,
          step.panelIndex,
          step.elementIndex,
          image,
        )
        break
      case Steps.EditBackgroundPicture:
        setElementImage(step.fullBleedIndex, undefined, 0, image)
        break
    }
  }

  return (
    <div style={{ height: '100%', overflowY: 'auto' }}>
      <Images
        result={images.map(image => ({
          ...image,
          smallThumb: image.smallThumb ? image.smallThumb : image.url,
        }))}
        isLoading={isLoadingMore}
        hasMore={hasMore}
        loadMore={loadMore}
        onSelect={onSelect}
        deleteImage={id => mutations.deleteImage({ id })}
      />
      <UploadFooter />
    </div>
  )
}

export default suspenseBoundary({
  component: SOCImages,
  unresolved: <CircularProgress />,
  failure: DefaultError,
})
